import React from "react"

import {Card, Radio, Typography, Space, Divider, Spin, Col,Image} from "antd";
import {EnvironmentOutlined,LinkOutlined,ClockCircleOutlined} from "@ant-design/icons"

import ApiService from "../../../services/ApiService"

import {ASSET_URL} from "../../../config";
import InfiniteScroll from "react-infinite-scroll-component";
import Link from "next/link";
import Masonry from "react-masonry-css";
import logger from "../../../services/logger"

const {Text}=Typography

const ummahMasonryStyles = `
.ummah-masonry-grid { display: flex; margin-left: -10px; width: auto; }
.ummah-masonry-grid_column { padding-left: 10px; background-clip: padding-box; }
.ummah-masonry-grid_column > * { margin-bottom: 10px; }
`;

export default class ImageRender extends React.Component{

    state = {
        data: [],
        loading: false,
        page:0,
        finished:false,
    };

    componentDidMount() {
        this.setState({loading:true},()=>{
            this.getData(true)
        })
    }

    async getData(init=false)
    {
        const context=this.props.context
        const {org}=context

        var page=this.state.page+1
        if(init){
            page=1
        }

        this.setState({ loading: true });
        var res=await ApiService.get("/galeries/images/"+this.props.galerie.id+"/"+page)
        logger.debug({ res }, "res")

        var finished=true
        if(res.data.length>0){
            finished=false
        }

        var finalData=[...this.state.data,...res.data]
        if(init){
            finalData=res.data
        }

        this.setState({
            loading: false,
            data: finalData,
            page:page,
            finished:finished
        });
    };


    render()
    {
        const context=this.props.context
        const {org}=context

        return(
          <div>


              {!this.state.loading && this.state.data.length==0 &&(
                  <div style={{marginTop:50,display:"flex",}}>
                      <span>Cet organisme n'a pas encore d'événement</span>
                  </div>
              )}

              <div className={`my-4 container-fluid`}>
                  <style dangerouslySetInnerHTML={{ __html: ummahMasonryStyles }} />
                  <Image.PreviewGroup>
                      <InfiniteScroll
                          dataLength={this.state.data.length} //This is important field to render the next data
                          next={()=>this.getData()}
                          hasMore={!this.state.finished}
                          //loader={<div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"100%"}}><Spin spinning/></div>}
                          //style={{display:"flex",flexWrap:"wrap",gap:30,overflow:"visible"}}
                          scrollableTarget={"main"}
                      >
                          <Masonry
                              breakpointCols={{default: 3, 900: 3, 750: 2, 350: 1}}
                              className="ummah-masonry-grid"
                              columnClassName="ummah-masonry-grid_column"
                          >
                              {this.state.data.map((image,i)=>(
                                  <Image key={i} src={ASSET_URL+"/"+image} style={{borderRadius:20,objectFit:"contain",width:"100%"}}/>
                              ))}
                          </Masonry>
                      </InfiniteScroll>
                  </Image.PreviewGroup>
              </div>
          </div>
        )
    }
}

/*

*/
